import { Component } from 'react';
import { connect } from 'react-redux';

import { Layout, Title, NeedHelp } from 'common/components/layout';
import SubMenu from 'profile/common/SubMenu';
import { getReservation } from 'redux/reservations/actions';

// import OrderSummary from './components/OrderSummary';
import CustomerDetails from './components/CustomerDetails';
import Notes from './components/Notes';
import ReservationDetail from './components/ReservationDetail';
import ReservationSummaryReceipt from './components/ReservationSummaryReceipt';

class OrderHistoryView extends Component {
  componentDidMount() {
    const { props } = this;
    props.getReservation(props.match.params.id);
  }

  render() {
    const { reservations, settings, customer, match } = this.props;
    const reservationId = match.params.id;
    if (!settings.data || !reservations.data || !customer.data) {
      return (
        <Layout title="Reservation View" loading>
          <Title>Your Account</Title>
          <SubMenu />
        </Layout>
      );
    }
    const reservation = reservations.data[reservationId];
    return (
      <Layout title={`Reservation No. ${reservation.reservationNumber}`}>
        <Title>Your Account</Title>
        <SubMenu />

        <div className="c7-account__order-detail">
          <h2>
            <span>Reservation No. {reservation.reservationNumber}</span>
            Thank you {customer.data.firstName}!
          </h2>

          <ReservationSummaryReceipt
            reservation={reservation}
            settings={settings}
          />

          <div className="c7-account__order-detail__customer-details">
            <ReservationDetail reservation={reservation} settings={settings} />
            <CustomerDetails reservation={reservation} />
            <Notes reservation={reservation} />
            <NeedHelp
              type="Reservation"
              reservationNumber={reservation.reservationNumber}
              customer={customer.data}
              settings={settings}
            />
          </div>
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  reservations: state.reservation,
  settings: state.setting,
  customer: state.customer
});

export default connect(mapStateToProps, {
  getReservation
})(OrderHistoryView);
